import React from 'react';
import Text from '@amzn/meridian/text';
import DisplaySubMetric from './DisplaySubMetric';
import Row from '@amzn/meridian/row';
import { FormattedMessage } from 'react-intl';
import { DisplaySubMetricsProps } from '../types';
import {
  DSRDataCheck,
  SUBMETRIC_FONT_SIZE,
  SUBMETRIC_ROW_WIDTHS,
} from '../helper';
import { ControlledExpander } from './Util/ControlledExpander';
import Column from '@amzn/meridian/column';
import NoSubMetric from './Util/NoSubMetric';

const DisplayDSRSubMetrics: React.FC<DisplaySubMetricsProps> = ({
  metrics,
}: DisplaySubMetricsProps): React.ReactElement => {
  if (!metrics.DSR?.submetrics) {
    return <></>;
  }
  if (DSRDataCheck(metrics.DSR?.submetrics!)) {
    return <NoSubMetric />;
  }
  const { dsrDenominator, dsrYes } = metrics.DSR?.submetrics!;

  return (
    <Column spacing='none' width='100%'>
      {dsrDenominator && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <ControlledExpander
            title={
              <Text type={SUBMETRIC_FONT_SIZE}>
                <FormattedMessage
                  id='cs_perfportal_lighthouse_dsrDenominator'
                  defaultMessage='DSR Denominator'
                />
              </Text>
            }
            type='list'
          >
            <Text type={SUBMETRIC_FONT_SIZE}>
              <FormattedMessage
                id='cs_perfportal_lighthouse_dsrDenominator_def'
                defaultMessage='Sum of total packages related to contacts that were handled.'
              />
            </Text>
          </ControlledExpander>
          <DisplaySubMetric value={dsrDenominator.datapoint} isBold />
          <DisplaySubMetric
            value={dsrDenominator.networkAverage}
            datapointNull={dsrDenominator.datapoint === null}
          />
        </Row>
      )}
      {dsrYes && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <ControlledExpander
            title={
              <Text type={SUBMETRIC_FONT_SIZE}>
                <FormattedMessage
                  id='cs_perfportal_lighthouse_dsrSuccess'
                  defaultMessage='DSR Yes/Success'
                />
              </Text>
            }
            type='list'
          >
            <Text type={SUBMETRIC_FONT_SIZE}>
              <FormattedMessage
                id='cs_perfportal_lighthouse_dsrSuccess_def'
                defaultMessage='Sum of Packages which resulted in delivery success.'
              />
            </Text>
          </ControlledExpander>
          <DisplaySubMetric value={dsrYes.datapoint} isBold />
          <DisplaySubMetric
            value={dsrYes.networkAverage}
            datapointNull={dsrYes.datapoint === null}
          />
        </Row>
      )}
    </Column>
  );
};

export default DisplayDSRSubMetrics;
